const SSO_LOGIN_TYPE = {
  SAML_COOKIE: 'saml_cookie',
};

const SSO_COOKIE_NAME = 'nonce_sso_auth_data';

export { SSO_COOKIE_NAME, SSO_LOGIN_TYPE };
